import styled from 'styled-components';
import { colors } from '@atlaskit/theme';

// @source
import { theme } from '../../styles';

export const Progress = styled.div`
  padding: 2.5rem 0;
  background-color: ${theme.background};
`;

export const ProgressContainer = styled.div`
  margin: 0 auto;
  max-width: 500px;

  & > div > div {
    margin-top: 0
  }
`;

export const UploadTemplate = styled.div`
  padding: 3rem 0;
  max-width: 675px;
  margin: 0 auto;
  text-align: center;
`;

export const FileDragArea = styled.div`
  position: relative;
  height: 15rem;
  border: 1px dashed ${theme.border};
  border-radius: 2px;
  align-items: center;
  display: flex;
  margin: 1.5rem 0;

  &:hover {
    border-color: ${colors.N50};
  }

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 10;
    cursor: pointer;
  }

  p {
    margin-top: 1.75rem;
  }
`;

export const UploadFileIcon = styled.div`
  margin: 0 auto;
  text-align: center;
`;

export const Finish = styled.div`
  margin: 0 auto;
  max-width: 500px;
  padding: 3rem 0;
  text-align: center;
`;
